import { PublicClientApplication } from "@azure/msal-browser";

const appId = import.meta.env.VITE_APP_ID;
const appIdBackend = import.meta.env.VITE_AD_BACKEND_ID;
const teenantId = import.meta.env.VITE_AUTHORITY_ID;
const redirectUri = import.meta.env.VITE_APP_REDIRECT_URI;

/*export const msalConfig = {
  auth: {
    clientId: appId,
    authority: `https://login.microsoftonline.com/${teenantId}`,
    redirectUri: redirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
*/
export const msalConfig = {
  auth: {
    clientId: appId,
    authority: `https://login.microsoftonline.com/${teenantId}`,
    redirectUri: redirectUri,
    scopes: [
      "openid",
      "profile",
      "email",
      `api://${appIdBackend}/acceso.completo`,
    ],
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache   will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};
/** Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 */
export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "email",
    `api://${appIdBackend}/acceso.completo`,
  ],
  redirectUri: redirectUri,
};
